export default {"src":"/_next/static/media/email-slateus.9d127915.svg","height":100,"width":100};